module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAACXBIWXMAAAsSAAALEgHS3X78AAAA00lEQVQ4y62UwQ3DIAxFn6PemxEyQkbICB2BUbpJM0pG6AiMwAbuxVQ0AQJRkSwUsB/B/wsABwRAG2NVVdLAAAGY95uZ5CwobpwCEojbgwC0BRAhNv+AblwYqrqKCMBLRBCjS0uxiATgflivQURkAibAq6ov5GixJ8Bm947yu0qzi5AZGG0OwNYNyfyVuwSxYp9zaQ9kAZ7/us7DkqccZKh4Ykk+FzvNVwx4oI+JtP5M4jOzRZnfqhpKZuuyfQkyJCdeAXzrmh+ljPyxb93PYxoBcB/s3+vTL/pV0QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Close bill.png
// module id = 133
// module chunks = 0 1